"use client";
import { Action } from "@/context/AnalyticsProvider";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import { useEffect } from "react";
import type { GPOnboardingStepProps } from "./utils";

export const SilverRewardAchieved = ({
  onNext,
  isVisible,
  track,
}: GPOnboardingStepProps) => {
  useEffect(() => {
    if (!isVisible) return;

    track({
      action: Action.SUCCEEDED,
      extras: {
        control: "silver-reward",
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    const timeout = setTimeout(() => onNext(), 1500);
    return () => clearTimeout(timeout);
  }, [onNext, isVisible, track]);

  return (
    <div className="flex-grow flex flex-col items-center justify-between gap-y-10">
      {/* Title */}
      <div>
        <h2 className="text-[clamp(1.25rem,6.25vw,1.875rem)] font-bold leading-[clamp(1.5rem,6.25vw,2.25rem)] text-center">
          Reward upgraded to
          <br />
          Silver tier
        </h2>
      </div>
      {/* Empty spacer for consistent layout */}
      <div />
    </div>
  );
};
